import React, { PureComponent } from 'react';
import { createMainController } from '../../../services/createMainController';
import { OnBoardingWrapperWithRouter } from '@wix/branding-client-lib';
import * as routes from '../../../../universal/main/mainRoutes';
import * as descriptor from '../../../../universal/main/onboardingDescriptor';

const descriptorList = descriptor.DESCRIPTOR_ONBOARDING_LIST;

class MainController extends PureComponent {
  translateDescriptorInfo(info) {
    const translatedInfo = info;
    const { t } = this.props;
    const title = translatedInfo.title;
    const subTitle = translatedInfo.subTitle;
    translatedInfo.title = t(title);
    translatedInfo.subTitle = t(subTitle);
  }

  tanslateDescriptor() {
    const { t } = this.props;
    for (const item in descriptorList) {
      const descriptorInfo = descriptorList[item];
      const title = descriptorInfo.title;
      const subTitle = descriptorInfo.subTitle;
      descriptorInfo.title = t(title);
      descriptorInfo.subTitle = t(subTitle);
    }
  }

  showHeader(pathname) {
    for (const item in descriptorList) {
      if (descriptorList[item].path === pathname) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { location, goToRoute } = this.props;
    const pathname = location.pathname;
    const showHeader = this.showHeader(pathname);
    this.tanslateDescriptor();
    if (showHeader) {
      return (
        <OnBoardingWrapperWithRouter
          goToRoute={goToRoute}
          routes={routes}
          onBoardingDescriptor={descriptorList}
          wixLogoLink="/business/name-generator/esh"
          bng={true}
        />
      );
    }
    return null;
  }
}

export default createMainController(MainController);
